<template>
  <div class="sentiment-page">
    <page-header-component
      icon="bi bi-emoji-smile"
      title="Analytics Sentiment"
    />
    <div class="row">
      <div class="col-md-4 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Total Sentiment Media Konvensional</h4>
              <p class="small hint-text">
                Total Sentiment Media Konvensional per Channel
              </p>
            </div>
          </div>
          <div class="card-body">
            <pie-chart-component :data="pie_chart" />
          </div>
        </div>
      </div>
      <div class="col-md-8 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Trend Sentiment Media Konvensional</h4>
              <p class="small hint-text">
                Grafik Tren Sentiment Media Konvensional per Channel
              </p>
            </div>
          </div>
          <div class="card-body">
            <line-chart-component
              :series="line_chart"
              el="linechart-sentimen-medkon"
              mode="single"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Total Sentiment Media Sosial</h4>
              <p class="small hint-text">
                Total Sentiment Media Sosial per Channel
              </p>
            </div>
          </div>
          <div class="card-body">
            <pie-chart-component :data="pie_chart" />
          </div>
        </div>
      </div>
      <div class="col-md-8 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Trend Sentiment Media Sosial</h4>
              <p class="small hint-text">
                Grafik Tren Sentiment Media Sosial per Channel
              </p>
            </div>
          </div>
          <div class="card-body">
            <line-chart-component
              :series="line_chart_medsos"
              el="linechart-sentimen-medsos"
              mode="single"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Total Sentiment Positif per Provinsi</h4>
              <p class="small hint-text">
                Daftar Top 10 Provinsi dengan Sentiment Positif
              </p>
            </div>
          </div>
          <div class="card-body">
            <div class="top-provinsi">
              <div class="card pb-2 shadow bg-transparent">
                <div
                  class="d-flex align-items-center"
                  @click="positif_collapse = !positif_collapse"
                  style="cursor: pointer"
                >
                  <h6 class="mx-2">Top 10 Provinsi</h6>
                  <i
                    v-if="positif_collapse"
                    class="bi bi-chevron-up ml-auto mr-2"
                    style="font-size: 10px"
                  ></i>
                  <i
                    v-else
                    class="bi bi-chevron-down ml-auto mr-2"
                    style="font-size: 10px"
                  ></i>
                </div>
                <div
                  class="collapse"
                  id="positif-collapse"
                  :class="positif_collapse ? 'hide' : 'show'"
                >
                  <div
                    v-for="data in top_10"
                    :key="data.id"
                    class="d-flex mx-2"
                  >
                    <small class="mr-auto">{{ data.nama }}</small>
                    <small class="ml-auto"
                      ><strong>{{
                        thousand_separator(data.mention)
                      }}</strong></small
                    >
                  </div>
                </div>
              </div>
            </div>
            <bubble-maps-component
              :id="'sentimen-provinsi-positif'"
              :dataset="maps_data"
              :color="'#28a745'"
              :clickable="false"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Total Sentiment Negatif per Provinsi</h4>
              <p class="small hint-text">
                Daftar Top 10 Provinsi dengan Sentiment Negatif
              </p>
            </div>
          </div>
          <div class="card-body">
            <div class="top-provinsi">
              <div class="card pb-2 shadow bg-transparent">
                <div
                  class="d-flex align-items-center"
                  @click="negatif_collapse = !negatif_collapse"
                  style="cursor: pointer"
                >
                  <h6 class="mx-2">Top 10 Provinsi</h6>
                  <i
                    v-if="negatif_collapse"
                    class="bi bi-chevron-up ml-auto mr-2"
                    style="font-size: 10px"
                  ></i>
                  <i
                    v-else
                    class="bi bi-chevron-down ml-auto mr-2"
                    style="font-size: 10px"
                  ></i>
                </div>
                <div
                  class="collapse"
                  id="negatif-collapse"
                  :class="negatif_collapse ? 'hide' : 'show'"
                >
                  <div
                    v-for="data in top_10"
                    :key="data.id"
                    class="d-flex mx-2"
                  >
                    <small class="mr-auto">{{ data.nama }}</small>
                    <small class="ml-auto"
                      ><strong>{{
                        thousand_separator(data.mention)
                      }}</strong></small
                    >
                  </div>
                </div>
              </div>
            </div>
            <bubble-maps-component
              :id="'sentimen-provinsi-negatif'"
              :dataset="maps_data"
              :color="'#dc3545'"
              :clickable="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Persentase Emotion</h4>
            </div>
          </div>
          <div class="card-body">
            <pie-chart-component :data="pie_chart" />
          </div>
        </div>
      </div>
      <div class="col-md-8 px-gap">
        <div class="card shade">
          <div class="card-header">
            <div class="pull-left m-t-5 m-b-5">
              <h4 class="m-b-0">Trend Emotion</h4>
            </div>
          </div>
          <div class="card-body">
            <line-chart-component
              :series="line_chart_medsos"
              el="linechart-emotion"
              mode="single"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import page_header from "@/views/components/page_header.vue";
import pie_chart from "@/views/components/chart/pie_chart.vue";
import line_chart from "@/views/components/chart/line_chart.vue";
import bubble_maps_chart from "@/views/components/chart/bubble_maps_chart.vue";
import general_plugin from "@/plugins/generalPlugins.js";

export default {
  name: "Sentiment",
  title: "Analytics Sentiment | Online Media Monitoring",
  components: {
    "page-header-component": page_header,
    "pie-chart-component": pie_chart,
    "line-chart-component": line_chart,
    "bubble-maps-component": bubble_maps_chart,
  },
  data() {
    return {
      positif_collapse: false,
      negatif_collapse: false,
      pie_chart: [
        { color: "#28a745", name: "Positif", y: 12104 },
        { color: "#0e6d87AA", name: "Netral", y: 1132 },
        { color: "#dc3545AA", name: "Negatif", y: 302 },
      ],
      line_chart: {
        x: [
          "08 Dec 2022",
          "09 Dec 2022",
          "10 Dec 2022",
          "11 Dec 2022",
          "12 Dec 2022",
          "13 Dec 2022",
          "14 Dec 2022",
        ],
        y: [
          {
            color: "#28a745",
            data: [1996, 1405, 818, 722, 2997, 2787, 1379],
            name: "Positif",
          },
          {
            color: "#0e6d87AA",
            data: [133, 109, 47, 34, 290, 391, 128],
            name: "Netral",
          },
          {
            color: "#dc3545AA",
            data: [53, 39, 6, 10, 32, 120, 42],
            name: "Negatif",
          },
        ],
        yName: "Total",
      },
      line_chart_medsos: {
        x: [
          "06 Dec 2022",
          "07 Dec 2022",
          "10 Dec 2022",
          "11 Dec 2022",
          "12 Dec 2022",
          "13 Dec 2022",
          "14 Dec 2022",
        ],
        y: [
          {
            color: "#28a745",
            data: [1996, 1405, 818, 722, 2997, 2787, 1379],
            name: "Positif",
          },
          {
            color: "#0e6d87AA",
            data: [133, 109, 47, 34, 290, 391, 128],
            name: "Netral",
          },
          {
            color: "#dc3545AA",
            data: [53, 39, 6, 10, 32, 120, 42],
            name: "Negatif",
          },
        ],
        yName: "Total",
      },
      maps_data: [
        {
          hc_key: "id-ku",
          z: 90,
        },
        {
          hc_key: "id-1024",
          z: 25,
        },
        {
          hc_key: "id-ki",
          z: 67,
        },
        {
          hc_key: "id-se",
          z: 117,
        },
        {
          hc_key: "id-ba",
          z: 57,
        },
        {
          hc_key: "id-sg",
          z: 87,
        },
        {
          hc_key: "id-be",
          z: 34,
        },
        {
          hc_key: "id-jr",
          z: 55,
        },
        {
          hc_key: "id-ja",
          z: 67,
        },
        {
          hc_key: "id-jt",
          z: 86,
        },
      ],
      top_10: [
        {
          id: 1,
          nama: "Sulawesi Selatan",
          mention: 117,
        },
        {
          id: 2,
          nama: "Sulawesi Tenggara",
          mention: 90,
        },
        {
          id: 3,
          nama: "Jawa Tengah",
          mention: 87,
        },
        {
          id: 4,
          nama: "Kalimantan Utara",
          mention: 86,
        },
        {
          id: 5,
          nama: "Kalimantan Timur",
          mention: 60,
        },
        {
          id: 6,
          nama: "Jambi",
          mention: 50,
        },
        {
          id: 7,
          nama: "Jawa Barat",
          mention: 49,
        },
        {
          id: 8,
          nama: "Bali",
          mention: 23,
        },
        {
          id: 9,
          nama: "Bengkulu",
          mention: 20,
        },
        {
          id: 10,
          nama: "Lampung",
          mention: 10,
        },
      ],
    };
  },
  methods: {
    thousand_separator: function (str) {
      return general_plugin.thousandSeparator(str);
    },
  },
};
</script>
<style scoped>
.top-provinsi {
  position: absolute;
  width: 10rem;
  z-index: 1;
  right: 0;
  margin-right: 2rem;
}
</style>